import { DIGITAL_ALLOCATION_TYPE_IMPRESSIONS } from '../../Partnerships/RightForms/fields'
import { IMPRESSIONS } from '../fields'
import { BUDGET_LIFETIME } from '../../CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/fields'
import { BUDGET_DAILY } from '../../CampaignForms/fields'

export const calculateBudgetFromImpressions = ({ impressions, rightBidCap }) => {
  return (impressions / 1000) * rightBidCap
}

export const calculateImpressionsFromBudget = ({ budget, rightBidCap }) => {
  return (budget / rightBidCap) * 1000
}

export const getCampaignBudget = ({ values, rightAllocationType, rightBidCap, budgetType = BUDGET_LIFETIME }) => {
  if (rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS) {
    return calculateBudgetFromImpressions({
      impressions: values[IMPRESSIONS],
      rightBidCap
    })
  } else {
    if (budgetType === BUDGET_LIFETIME) {
      return values[BUDGET_LIFETIME]
    } else if (budgetType === BUDGET_DAILY) {
      return values[BUDGET_DAILY]
    }
  }
}
